import {lazy} from 'react';

import * as contentConstants from './contentConstants';
import * as contentInfoConstants from './ContentInfo/contentInfoConstants';

import useContentDepartments from './hooks/useContentDepartments';
import useContentDepartmentsI18n from './hooks/useContentDepartmentsI18n';

const ContentContents = lazy(() => import('./ContentContents'));
const ContentDepartmentSelect = lazy(() => import('./ContentDepartmentSelect'));
const ContentDistributionForm = lazy(() => import('./ContentDistributionForm'));
const ContentForm = lazy(() => import('./ContentForm'));
const ContentInfo = lazy(() => import('./ContentInfo/ContentInfo'));
const ContentStatus = lazy(() => import('./ContentStatus'));
const ContentTile = lazy(() => import('./ContentTile'));


export {
    ContentContents,
    ContentDepartmentSelect,
    ContentDistributionForm,
    ContentForm,
    ContentInfo,
    ContentStatus,
    ContentTile,
    contentConstants,
    contentInfoConstants,
    useContentDepartments,
    useContentDepartmentsI18n
};


export default null;
